const TOUR_STORAGE_PREFIX = "aq_qms_quiz_builder_tour_v1";

function getStorageKey(staffId) {
  const id = String(staffId || "").trim();
  return id ? `${TOUR_STORAGE_PREFIX}_${id}` : TOUR_STORAGE_PREFIX;
}

export function hasCompletedQmsQuizBuilderTour(staffId) {
  try {
    return localStorage.getItem(getStorageKey(staffId)) === "1";
  } catch {
    return false;
  }
}

export function markQmsQuizBuilderTourCompleted(staffId) {
  try {
    localStorage.setItem(getStorageKey(staffId), "1");
  } catch {
    /* ignore quota errors */
  }
}
